import { createContext, useContext, useEffect } from 'react';

/**
 * The workshop board a page is rendered on. A page that outgrows the board calls
 * `release` and the board opens out into a full page with the page still mounted,
 * so nothing it holds (Play Now's socket) is torn down. Null off the workshop.
 */
export const BoardFrame = createContext<{ release(): void } | null>(null);

/** For a page that can sit on a board: once `outgrown`, it takes the whole screen. */
export function useOutgrowBoard(outgrown: boolean) {
  const frame = useContext(BoardFrame);
  useEffect(() => {
    if (outgrown) frame?.release();
  }, [outgrown, frame]);
}
